import Vue from 'vue'
import phaseOperationsComplexOption from './phaseOperationsComplex.vue'

const PhaseOperationsComplex = Vue.extend(phaseOperationsComplexOption)

export function templatePhaseOperationsComplexVue({
  module,
  postMessage,
  callModule
}) {
  const phaseOperationsComplex = new PhaseOperationsComplex({
    propsData: {
      module
    },
    methods: {
      postMessage,
      callModule
    }
  }).$mount()
  return phaseOperationsComplex.$el
}
